import type { GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200 } from '@fukuri-admins/apis/client/gen/model';
import type { CustomFieldDefinition } from '~/types/resources/CustomFieldDefinition';

type IConvertToCustomFieldDefinitions = (
  data: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200
) => CustomFieldDefinition[];

/**
 * カスタムフィールド定義APIレスポンスをアプリ内型に変換する（新版）
 *
 * target_model が 'client' の定義のみを企業編集フォームの表示・編集対象とする。
 * 'user_profile' 向けの定義は対象外のため、変換前にフィルタで除外する。
 * PEN-986: 移行期間中は「取引店舗」カスタムフィールドを非表示にする（定義削除後に PEN-987 で撤去）
 */
export const convertToCustomFieldDefinitions: IConvertToCustomFieldDefinitions = data =>
  data.custom_field_definitions
    .filter(def => def.target_model === 'client' && def.label !== '取引店舗')
    .map(def => ({
      id: def.id,
      label: def.label,
      input_type: def.input_type,
      value_type: def.value_type,
      target_model: 'client',
      options: def.options
        ? Object.fromEntries(Object.entries(def.options).map(([k, v]) => [k, String(v ?? '')]))
        : undefined,
    }));
